import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { VoiceTooltip } from './VoiceTooltip';
import { VoicePreview } from './VoicePreview';
import { AudioPlayer } from '@/components/media/AudioPlayer';
import { useState } from 'react';
import type { MediaAsset } from '@/lib/blob-service';
import { Badge } from '@/components/ui/badge';

interface VoiceCardProps {
  id: string;
  name: string;
  description: string;
  preview: MediaAsset;
  avatarUrl?: string;
  recommended?: boolean;
  isSelected: boolean;
  onSelect: () => void;
}

export function VoiceCard({
  id,
  name,
  description,
  preview,
  avatarUrl,
  recommended = false,
  isSelected,
  onSelect,
}: VoiceCardProps) {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      <motion.div
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <Card
          className={`cursor-pointer p-6 ${
            isSelected
              ? 'border-primary ring-2 ring-primary ring-opacity-50'
              : ''
          }`}
          onClick={onSelect}
        >
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold">{name}</h3>
                  {recommended && <Badge variant="secondary">Recommended</Badge>}
                </div>
                <VoiceTooltip
                  name={name}
                  avatarUrl={avatarUrl}
                  onClick={() => setShowPreview(true)}
                />
              </div>
              <p className="text-sm text-muted-foreground">{description}</p>
            </div>
            <AudioPlayer
              asset={preview}
              showDuration={false}
              className="mt-4"
              simpleMode
            />
          </div>
        </Card>
      </motion.div>

      <VoicePreview
        open={showPreview}
        onOpenChange={setShowPreview}
        name={name}
        avatarUrl={avatarUrl}
        description={description}
      />
    </>
  );
}
